import type { SavedDocument } from '../types/document'
import { daysUntil } from './explain'

// "My papers": saved documents that have a last date, on one timeline. Works
// only from what the person chose to save on this phone; nothing is sent.

export interface TrackedPaper {
  item: SavedDocument
  iso: string
  /** Whole days left; negative once the date has passed. */
  days: number
  done: boolean
}

/** Saved papers with a last date, soonest first; done ones last. */
export function trackedPapers(items: SavedDocument[], today = new Date()): TrackedPaper[] {
  return items
    .flatMap((item) => {
      const iso = item.doc.deadline?.iso
      return iso ? [{ item, iso, days: daysUntil(iso, today), done: Boolean(item.doneAt) }] : []
    })
    .sort((a, b) => Number(a.done) - Number(b.done) || a.iso.localeCompare(b.iso))
}

/** Papers to ask about on the home screen: not done, last date within a week or up to a month ago. */
export function papersNeedingCheckIn(items: SavedDocument[], today = new Date()): TrackedPaper[] {
  return trackedPapers(items, today).filter((t) => !t.done && t.days <= 7 && t.days >= -30)
}

/** "in 3 days", "tomorrow", "2 days ago" in the reader's language. */
export function relativeDays(days: number, bcp47: string): string {
  try {
    return new Intl.RelativeTimeFormat(bcp47, { numeric: 'auto' }).format(days, 'day')
  } catch {
    return `${days}`
  }
}
